"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowCols = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _fieldType = require("../fieldType");

var _locale = require("../locale");

var _jsonComponent = require("../common/jsonComponent");

var _dec, _class, _class2, _descriptor, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ShowCols = (_dec = (0, _vuePropertyDecorator.Model)('change'), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(ShowCols, _Mixins);

  var _super = _createSuper(ShowCols);

  function ShowCols() {
    var _this;

    (0, _classCallCheck2.default)(this, ShowCols);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "value", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.visible = false;
    _this.search = '';
    return _this;
  }

  (0, _createClass2.default)(ShowCols, [{
    key: "type",
    get: function get() {
      return 'table';
    }
  }, {
    key: "options",
    get: function get() {
      var _this2 = this;

      var list = _fieldType.FieldType.trans2ListByType(this.formItems);

      var out = list.map(function (item) {
        return {
          label: item.title,
          value: item.dataIndex
        };
      });

      if (this.search) {
        return out.filter(function (item) {
          return item.label.includes(_this2.search);
        });
      }

      return out;
    }
  }, {
    key: "checkedLength",
    get: function get() {
      var options = this.options,
          _this$value = this.value,
          value = _this$value === void 0 ? [] : _this$value;
      return options.filter(function (opt) {
        return value.includes(opt.value);
      }).length;
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var newValue = (this.value || []).slice();
      var index = newValue.indexOf(value);

      if (index === -1) {
        newValue.push(value);
      } else {
        newValue.splice(index, 1);
      }

      this.$emit('change', newValue);
    }
  }, {
    key: "onAllChange",
    value: function onAllChange() {
      var checkedLength = this.checkedLength,
          options = this.options,
          _this$value2 = this.value,
          value = _this$value2 === void 0 ? [] : _this$value2;
      var newValue = value.slice();

      if (checkedLength === options.length) {
        options.forEach(function (opt) {
          var index = newValue.indexOf(opt.value);
          newValue.splice(index, 1);
        });
      } else {
        options.forEach(function (opt) {
          if (!value.includes(opt.value)) {
            newValue.push(opt.value);
          }
        });
      }

      this.$emit('change', newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var h = arguments[0];
      var checkedLength = this.checkedLength,
          _this$value3 = this.value,
          value = _this$value3 === void 0 ? [] : _this$value3,
          options = this.options,
          onChange = this.onChange,
          search = this.search,
          onAllChange = this.onAllChange;
      return h("a-popover", {
        "attrs": {
          "trigger": "click",
          "title": (0, _locale.tl)('showCols.title'),
          "placement": "bottom"
        },
        "model": {
          value: _this3.visible,
          callback: function callback($$v) {
            _this3.visible = $$v;
          }
        }
      }, [h("span", {
        "class": "json-table-actions-text"
      }, [h("a-icon", {
        "attrs": {
          "type": "eye",
          "theme": "filled"
        },
        "class": "json-table-primary-icon"
      }), (0, _locale.tl)('showCols.title')]), h("div", {
        "slot": "content",
        "class": "json-table-show-cols"
      }, [h("a-input-search", {
        "model": {
          value: _this3.search,
          callback: function callback($$v) {
            _this3.search = $$v;
          }
        }
      }), h("div", {
        "class": "checkbox-block"
      }, [h("a-checkbox", {
        "key": "all",
        "attrs": {
          "checked": checkedLength === options.length,
          "indeterminate": checkedLength !== options.length && checkedLength !== 0
        },
        "on": {
          "change": function change() {
            return onAllChange();
          }
        }
      }, [search ? (0, _locale.tl)('showCols.searchCheckAll') : (0, _locale.tl)('showCols.checkAll')]), options.map(function (opt) {
        return h("a-checkbox", {
          "key": opt.value,
          "attrs": {
            "checked": value.includes(opt.value)
          },
          "on": {
            "change": function change() {
              return onChange(opt.value);
            }
          }
        }, [opt.label]);
      })])])]);
    }
  }]);
  return ShowCols;
}((0, _vuePropertyDecorator.Mixins)(_jsonComponent.JsonComponent)), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.ShowCols = ShowCols;